import { Record, Union } from "./fable_modules/fable-library.3.7.18/Types.js";
import { record_type, option_type, list_type, string_type, union_type } from "./fable_modules/fable-library.3.7.18/Reflection.js";
import { StyleImports_createTheme_argsArray, StyleImports_createTheme_unit } from "../../src/Feliz.MaterialUI/./Styles.fs.js";
import { fromFlatEntries } from "../../src/Feliz.MaterialUI/./Flatten.fs.js";
import indigo from "@mui/material/colors/indigo";
import pink from "@mui/material/colors/pink";
import { cons, append, empty as empty_1, singleton as singleton_1, head, isEmpty, ofArray } from "./fable_modules/fable-library.3.7.18/List.js";
import lightBlue from "@mui/material/colors/lightBlue";
import { MuiHelpers_createElement } from "../../src/Feliz.MaterialUI/./Mui.fs.js";
import { AppBar, CssBaseline, Box, Drawer as Drawer_1, List, Collapse, ListItemText, ListItem, Toolbar as Toolbar_1, IconButton, Tooltip, Typography } from "@mui/material";
import { empty, toArray, singleton, delay, toList } from "./fable_modules/fable-library.3.7.18/Seq.js";
import { createElement } from "react";
import * as react from "react";
import Brightness4 from "@mui/icons-material/Brightness4";
import Brightness7 from "@mui/icons-material/Brightness7";
import BrightnessAuto from "@mui/icons-material/BrightnessAuto";
import { Interop_reactApi } from "./fable_modules/Feliz.1.68.0/./Interop.fs.js";
import GitHub from "@mui/icons-material/GitHub";
import { useFeliz_React__React_useState_Static_1505 } from "./fable_modules/Feliz.1.68.0/React.fs.js";
import { RouterModule_router, RouterModule_encodeParts } from "./fable_modules/Feliz.Router.3.8.0/./Router.fs.js";
import { map } from "./fable_modules/fable-library.3.7.18/Array.js";
import { equals, createObj } from "./fable_modules/fable-library.3.7.18/Util.js";
import { HookImports_useMediaQuery } from "../../src/Feliz.MaterialUI/./Hooks.fs.js";
import { ThemeProvider } from "@mui/material/styles";
import { defaultArg } from "./fable_modules/fable-library.3.7.18/Option.js";
import { printf, toText } from "./fable_modules/fable-library.3.7.18/String.js";
import { MarkdownViewer } from "./MarkdownViewer.fs.js";

export class ThemeMode extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Light", "Dark"];
    }
}

export function ThemeMode$reflection() {
    return union_type("App.ThemeMode", [], ThemeMode, () => [[], []]);
}

export class Model extends Record {
    constructor(CurrentPath, CustomThemeMode) {
        super();
        this.CurrentPath = CurrentPath;
        this.CustomThemeMode = CustomThemeMode;
    }
}

export function Model$reflection() {
    return record_type("App.Model", [], Model, () => [["CurrentPath", list_type(string_type)], ["CustomThemeMode", option_type(ThemeMode$reflection())]]);
}

export class Msg extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["SetPath", "ToggleCustomThemeMode"];
    }
}

export function Msg$reflection() {
    return union_type("App.Msg", [], Msg, () => [[["Item", list_type(string_type)]], []]);
}

export function init(path) {
    return new Model(path, void 0);
}

export function update(msg, m) {
    let matchValue;
    if (msg.tag === 1) {
        return new Model(m.CurrentPath, (matchValue = m.CustomThemeMode, (matchValue != null) ? ((matchValue.tag === 0) ? (void 0) : (new ThemeMode(0))) : (new ThemeMode(1))));
    }
    else {
        return new Model(msg.fields[0], m.CustomThemeMode);
    }
}

export const Theme_defaultTheme = StyleImports_createTheme_unit();

export const Theme_light = (() => {
    const merge = [];
    return StyleImports_createTheme_argsArray(fromFlatEntries(ofArray([["palette.mode", "light"], ["palette.primary", indigo], ["palette.secondary", pink], ["palette.background.default", "#fff"], ["typography.h1.fontSize", "3rem"], ["typography.h2.fontSize", "2rem"], ["typography.h3.fontSize", "1.5rem"]])), ...merge);
})();

export const Theme_dark = (() => {
    const merge = [];
    return StyleImports_createTheme_argsArray(fromFlatEntries(ofArray([["palette.mode", "dark"], ["palette.primary", lightBlue], ["palette.secondary", pink], ["palette.background.default", Theme_defaultTheme.palette.grey["900"]], ["typography.h1.fontSize", "3rem"], ["typography.h2.fontSize", "2rem"], ["typography.h3.fontSize", "1.5rem"], ["components.MuiAppBar.styleOverrides.colorDefault", {
        backgroundColor: Theme_defaultTheme.palette.grey.A700,
    }], ["components.MuiPaper.styleOverrides.root", {
        backgroundColor: Theme_defaultTheme.palette.grey.A700,
    }], ["components.MuiDrawer.styleOverrides.paper", {
        backgroundColor: Theme_defaultTheme.palette.grey["900"],
    }], ["components.MuiAppBar.defaultProps", {
        color: "default",
    }]])), ...merge);
})();

export function Toolbar(toolbarInputProps) {
    let matchValue, elements, props_10;
    const dispatch = toolbarInputProps.dispatch;
    const model = toolbarInputProps.model;
    const children_4 = ofArray([MuiHelpers_createElement(Typography, [["variant", "h6"], ["sx", {
        color: "inherit",
        flexGrow: 1,
    }], ["children", "Feliz.MaterialUI"]]), MuiHelpers_createElement(Tooltip, [["title", (matchValue = model.CustomThemeMode, (matchValue != null) ? ((matchValue.tag === 1) ? "Using dark theme" : "Using light theme") : "Using system light/dark theme")], ["children", MuiHelpers_createElement(IconButton, [["onClick", (_arg) => {
        dispatch(new Msg(1));
    }], ["color", "inherit"], (elements = toList(delay(() => {
        let props_6, props_4, props_2;
        const matchValue_1 = model.CustomThemeMode;
        return (matchValue_1 != null) ? ((matchValue_1.tag === 1) ? singleton((props_6 = {}, react.createElement(Brightness4, props_6))) : singleton((props_4 = {}, react.createElement(Brightness7, props_4)))) : singleton((props_2 = {}, react.createElement(BrightnessAuto, props_2)));
    })), ["children", Interop_reactApi.Children.toArray(Array.from(elements))])])]]), MuiHelpers_createElement(Tooltip, [["title", "Feliz.MaterialUI on GitHub"], ["children", MuiHelpers_createElement(IconButton, [["href", "https://github.com/ArtemyB/Feliz.MaterialUI"], ["component", "a"], ["color", "inherit"], ["children", (props_10 = {}, react.createElement(GitHub, props_10))]])]])]);
    return MuiHelpers_createElement(Toolbar_1, [["children", Interop_reactApi.Children.toArray(Array.from(children_4))]]);
}

export function MenuContainer(menuContainerInputProps) {
    let elements, elements_2;
    const children = menuContainerInputProps.children;
    const currentPath = menuContainerInputProps.currentPath;
    const pathPrefix = menuContainerInputProps.pathPrefix;
    const name = menuContainerInputProps.name;
    const isInPath = (!isEmpty(currentPath)) && (head(currentPath) === pathPrefix);
    const patternInput = useFeliz_React__React_useState_Static_1505(true);
    const isOpen = patternInput[0];
    const xs = [MuiHelpers_createElement(ListItem, [["onClick", (_arg) => {
        patternInput[1](!isOpen);
    }], ["button", true], (elements = [MuiHelpers_createElement(ListItemText, [["primary", name]])], ["children", Interop_reactApi.Children.toArray(Array.from(elements))])]), MuiHelpers_createElement(Collapse, [["in", isInPath ? true : isOpen], (elements_2 = [MuiHelpers_createElement(List, [["disablePadding", true], ["children", Interop_reactApi.Children.toArray(Array.from(children))]])], ["children", Interop_reactApi.Children.toArray(Array.from(elements_2))])])];
    return react.createElement(react.Fragment, {}, ...xs);
}

export function Drawer(drawerInputProps) {
    let elements_2, elements_1;
    const dispatch = drawerInputProps.dispatch;
    const model = drawerInputProps.model;
    const menuItem = (isNested, name, path) => {
        let elements;
        const fragment = RouterModule_encodeParts(path, 1);
        return MuiHelpers_createElement(ListItem, [["key", fragment], ["href", fragment], ["sx", map((arg_3) => ((delegateArg) => ((x) => createObj(arg_3(x)))(delegateArg)), toArray(delay(() => (isNested ? singleton((t) => singleton_1(["\u0026 " + ".MuiListItem-root", {
            paddingLeft: t.spacing(4),
        }])) : empty()))))], ["button", true], ["component", "a"], ["selected", equals(model.CurrentPath, path)], (elements = [MuiHelpers_createElement(ListItemText, [["inset", isNested], ["primary", name], ["primaryTypographyProps", {
            noWrap: false,
        }]])], ["children", Interop_reactApi.Children.toArray(Array.from(elements))])]);
    };
    return MuiHelpers_createElement(Drawer_1, [["sx", createObj(ofArray([["width", 300], ["flexShrink", 0], ["\u0026 " + ".MuiDrawer-paper", {
        width: 300,
        boxSizing: "border-box",
    }]]))], ["variant", "permanent"], ["open", true], (elements_2 = [MuiHelpers_createElement(Toolbar_1, []), MuiHelpers_createElement(List, [["component", "nav"], (elements_1 = [menuItem(false, "Home", empty_1()), createElement(MenuContainer, {
        name: "Usage",
        pathPrefix: "usage",
        currentPath: model.CurrentPath,
        children: [menuItem(true, "Installation", ofArray(["usage", "installation"])), menuItem(true, "Components/props", ofArray(["usage", "components-props"])), menuItem(true, "Components imports and global CSS classes", ofArray(["usage", "components-classes-and-imports"])), menuItem(true, "Styling", ofArray(["usage", "styling"])), menuItem(true, "Styling via the sx prop", ofArray(["usage", "sx-prop"])), menuItem(true, "Styling via classes", ofArray(["usage", "classes"])), menuItem(true, "Theming", ofArray(["usage", "themes"])), menuItem(true, "Localization", ofArray(["usage", "localization"])), menuItem(true, "Other hooks", ofArray(["usage", "hooks"]))],
    }), menuItem(false, "Ecosystem", singleton_1("ecosystem")), createElement(MenuContainer, {
        name: "Components",
        pathPrefix: "components",
        currentPath: model.CurrentPath,
        children: [menuItem(true, "Autocomplete", ofArray(["components", "autocomplete"]))],
    }), createElement(MenuContainer, {
        name: "Samples",
        pathPrefix: "samples",
        currentPath: model.CurrentPath,
        children: [menuItem(true, "Sign-in", ofArray(["samples", "sign-in"])), menuItem(true, "Date Pickers", ofArray(["samples", "date-time-pickers"]))],
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elements_1))])])], ["children", Interop_reactApi.Children.toArray(Array.from(elements_2))])]);
}

export function AppView(appViewInputProps) {
    let elements_4, _arg, elements_3, elements_2, elements, elements_1;
    const dispatch = appViewInputProps.dispatch;
    const model = appViewInputProps.model;
    const systemThemeMode = HookImports_useMediaQuery("(prefers-color-scheme: dark)") ? (new ThemeMode(1)) : (new ThemeMode(0));
    return RouterModule_router(createObj(ofArray([["onUrlChanged", (arg_1) => {
        dispatch(new Msg(0, arg_1));
    }], ["hashMode", 1], (elements_4 = singleton_1(MuiHelpers_createElement(ThemeProvider, [["theme", (_arg = defaultArg(model.CustomThemeMode, systemThemeMode), (_arg.tag === 0) ? Theme_light : Theme_dark)], (elements_3 = [MuiHelpers_createElement(Box, [["sx", (delegateArg) => ((x) => ({
        display: "flex",
    }))(delegateArg)], (elements_2 = [MuiHelpers_createElement(CssBaseline, []), MuiHelpers_createElement(AppBar, [["position", "fixed"], ["sx", (delegateArg_1) => ((x_1) => ({
        zIndex: x_1.zIndex.drawer + 1,
    }))(delegateArg_1)], (elements = [createElement(Toolbar, {
        model: model,
        dispatch: dispatch,
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elements))])]), MuiHelpers_createElement(Box, [["component", "nav"], ["sx", {
        width: 300 + "px",
        flexShrink: 0,
    }], ["children", createElement(Drawer, {
        model: model,
        dispatch: dispatch,
    })]]), MuiHelpers_createElement(Box, [["component", "main"], ["sx", {
        flexGrow: 1,
        padding: 3,
        width: ("calc(" + toText(printf("100%% - %ipx"))(300)) + ")",
    }], (elements_1 = [MuiHelpers_createElement(Toolbar_1, []), createElement(MarkdownViewer, {
        path: append(cons("pages", model.CurrentPath), singleton_1("index.md")),
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elements_1))])])], ["children", Interop_reactApi.Children.toArray(Array.from(elements_2))])])], ["children", Interop_reactApi.Children.toArray(Array.from(elements_3))])])), ["application", react.createElement(react.Fragment, {}, ...elements_4)])])));
}

